/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
// import axios from "axios";
import { headApi } from "utils/headApi";
// import { imgApi } from "utils/imgApi";
import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
import VisibilityIcon from '@material-ui/icons/Visibility';
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Button from "components/CustomButtons/Button.js";
import { localApi, credentials } from "utils/headApi";
// import Slide from "@material-ui/core/Slide";
// import Tooltip from "@material-ui/core/Tooltip";
// import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
// import Table from "components/Table/Tables.js";
import Tables from "components/Table/Table.js";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(profilePageStyle);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyl = makeStyles(aboutUsStyle);

export default function PaymentHistory({ ...rest }) {
    const [ordersList, setOrdersList] = React.useState([]);
    // const [userId, setUserId] = React.useState("");
    const [load, setLoad] = React.useState(false);

    const classes = useStyles();
    const history = useHistory();

    // const classesTable = useStylesTable();
    // const classeCart = useStyleCart();
    const classeTitel = useStyl();

    const activeSession = sessionStorage.getItem("sessionData");
    const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

    const date = Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    })
        .format(new Date())
        .replaceAll("/", "-");

    const current = new Date();
    const dateCurrent = `${current.getDate()}-${current.getMonth() + 1
        }-${current.getFullYear()}`;
    current.setDate(current.getDate() + 10);
    let dateEx = new Date(current).toLocaleDateString("de");

    async function getList() {
        const response = await fetch(localApi + `/clientGroup/allList`, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        });
        const json = await response.json();
        const regClient = json.ClientList.filter((f) => f.regId == userObj.id)[0];
        // console.log(regClient);

        const getList = await fetch(
            localApi +
            `/bankdetails/list/byAdminId/${userObj.admin.id}`, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        }
        );
        const res = await getList.json();
        const bb = res[0];
        // console.log(res);
        if (!bb) {
            setLoad(false);
            history.push("/");
        } else {
            setLoad(true);
            setOrdersList(bb);
        }
    }

    useEffect(() => {
        getList();
    }, []);

    return (
        <div>
            <Helmet>
                <title>My Orders Lists</title>
            </Helmet>
            {load ? (
                <>
                    <InshaHeader
                         brand="Home"
                        links={<InshaHeaderLink dropdownHoverColor="dark" />}
                        fixed
                        color="transparent"
                        changeColorOnScroll={{
                            height: 100,
                            color: "dark",
                        }}
                    />
                    <Parallax
                        image={require("assets/img/bg6.jpg").default}
                        filter="dark"
                        className={classes.parallax}
                    >
                        <div className={classeTitel.container}>
                            <GridContainer justify="center">
                                <GridItem
                                    md={8}
                                    sm={8}
                                    className={classNames(
                                        classeTitel.mlAuto,
                                        classeTitel.mrAuto,
                                        classeTitel.textCenter
                                    )}
                                >
                                    <h1 className={classeTitel.title}>Company Bank Details</h1>
                                    <h4></h4>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </Parallax>

                    <div
                        className={classes.container}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",     // ✅ make full width
                        }}
                    >
                        <GridContainer style={{ justifyContent: "center", width: "100%" }}>
                            <GridItem xs={12} sm={6} md={6}>
                                <Card>
                                    <CardBody>
                                        {/* KEY–VALUE SECTION */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>Bank Name:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.bankName}</span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>Account Name:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.accountName}</span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>Account Number:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.accountNumber}</span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>Account Type:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.accountType}</span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>IFSC Code:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.ifscCode}</span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>SHIFT/BIC Code:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.shiftCode}</span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                                <span style={{ width: "40%" }}>UPI Id:</span>
                                                <span style={{ width: "60%", fontWeight: "bold" }}>{ordersList.upiId}</span>
                                            </div>

                                            <img
                                                src={ordersList.qrUrl}
                                                alt="QR Code"
                                            />
                                        </div>
                                    </CardBody>

                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>

                    <Footer />
                </>
            ) : (
                ""
            )}
        </div>
    );
}
